function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.parentNode;
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    }
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.removeAttribute('open');
  }

  closeMenuDrawer() {
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
    });
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }

  openMenuDrawer() {

  }

}

customElements.define('menu-drawer', MenuDrawer);



class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.revealDrawer = document.querySelector('reveal-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.guestAddressing = document.querySelector('#GuestAddressingCheckbox')?.checked;
      this.customVenue = document.querySelector('custom-venue')?.getValue() === 'custom' ? document.querySelector('custom-venue').getProductData().id : null

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          return {
            id: response.id,
            title: response.product_title,
            variant_title: response.variant_title,
            type: response.product_type
          }
        })
        .then((product) => {
          if (!this.guestAddressing) return
          this.guestAdressingVariant = document.querySelector('#GuestAddressingVariant')?.value
          const items = [{
            id: this.guestAdressingVariant,
            quantity: 1,
            properties: {
              _product_id: product.id,
              _product_title: product.title
            }
          }]
          const addConfig = fetchConfig('javascript')
          addConfig.body = JSON.stringify({ items: items })
          return fetch(`${routes.cart_add_url}`, addConfig)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return response.status;
              }
              return response
            })
            .catch(err => console.error(err))

        })
        .then(() => {
          if (!this.customVenue) return
          const items = [{
            id: this.customVenue,
            quantity: 1,
          }]
          const addConfig = fetchConfig('javascript')
          addConfig.body = JSON.stringify({ items: items })
          return fetch(`${routes.cart_add_url}`, addConfig)
            .then(response => response.json())
            .then(response => {
              if (response.status) {
                this.handleErrorMessage(response.description);
                return response.status;
              }
              return response
            })
            .catch(err => console.error(err))
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.revealDrawer.toggle();
          this.cartDrawer.fetchAndOpenCart();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

  })
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateOptionLegends();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateInkColors();
    }
  }

  updateInkColors() {
    if (!this.currentVariant) return;
    this.inkLabels = document.querySelectorAll('[data-print-method]');
    if (!this.inkLabels.length > 0) return;
    this.inkLabels.forEach(color => {
      if (this.currentVariant.title.includes('Foil')) {
        if (color.dataset.printMethod) {
          color.classList.remove('visually-hidden');
        } else {
          color.classList.add('visually-hidden');
        }
      } else {
        if (color.dataset.printMethod) {
          color.classList.add('visually-hidden');
        } else {
          color.classList.remove('visually-hidden');
        }
      }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));
  }

  updateOptionLegends() {
    this.currentVariant.options.forEach((option, i) => {
      const label = document.getElementById(`${this.dataset.section}-option-${i}`);
      label.innerText = option
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        const preorder = (this.currentVariant.available && this.currentVariant.inventory_policy !== 'deny' && this.currentVariant.inventory_quantity <= 0) ? true : false;

        if (preorder) {
          this.setPreorder();
        } else {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          this.togglePersonalizeButton();
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const preorderMessage = document.getElementById(`preorder-message-${this.dataset.section}`);

    if (preorderMessage && window.variantStrings.preorder.message) {
      preorderMessage.textContent = '';
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (window.variantStrings.addToCartHtml) {
        const price = this.currentVariant.price / 100;
        addButtonText.innerHTML = window.variantStrings.addToCartHtml.replace('{{ price }}', `$${(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`);
      } else {
        addButton.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  togglePersonalizeButton() {
    const personalizeButton = document.getElementById(`reveal-drawer-${this.dataset.section}`);
    if (!personalizeButton) return;
    if (window.variantStrings.personalizeHtml) {
      const price = this.currentVariant.price / 100;
      personalizeButton.innerHTML = window.variantStrings.personalizeHtml.replace('{{ price }}', `$${(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`);
    } else {
      personalizeButton.textContent = window.variantStrings.personalize;
    }
  }

  setPreorder() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    const preorderMessage = document.getElementById(`preorder-message-${this.dataset.section}`);

    if (preorderMessage && window.variantStrings.preorder.message) {
      preorderMessage.textContent = window.variantStrings.preorder.message;
    }

    addButton.removeAttribute('disabled');
    addButtonText.textContent = window.variantStrings.preorder.label;

  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getCurrentVariant() {
    return this.currentVariant || null
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    if (this.querySelector('select')) {
      this.options.splice(this.querySelector('select').dataset.index, 0, this.querySelector('select').value)
    }
    // console.log(this.querySelector('select').dataset.index,this.options)
  }
}

customElements.define('variant-radios', VariantRadios);


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.buttons = this.querySelector('.slider-buttons');
    this.dotButtons = this.querySelectorAll('button[name="index"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.isAutoPlay = parseInt(this.dataset.autoplay);
    this.isPlaying = false;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    if (this.isAutoPlay) {
      const intersectionObserver = new IntersectionObserver((entries) => this.autoPlay(entries))
      intersectionObserver.observe(this.slider, { root: null, rootMargin: '0px', threshold: 0.2 });
    }

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.dotButtons.length > 0) {
      this.dotButtons.forEach(button => {
        button.addEventListener('click', this.onDotClick.bind(this));
      });
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.dotButtons.length > 0) {
      this.dotButtons.forEach(button => {
        button.classList.remove('is-active');
      });

      if (this.dotButtons[this.currentPage - 1]) {
        this.dotButtons[this.currentPage - 1].classList.add('is-active');
      }
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  autoPlay(entries) {
    // this.currentPage, this.totalPages
    if (!this.isAutoPlay) {
      return;
    }
    window.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        entries.forEach((entry) => {
          this.interval;
          if (entry.isIntersecting) {
            this.isPlaying = true;
            this.interval = window.setInterval(() => {
              if (this.currentPage < this.totalPages) {
                this.slider.scroll({
                  top: 0,
                  left: this.currentPage * this.sliderItemOffset,
                })
              } else {
                this.slider.scroll({
                  top: 0,
                  left: 0,
                })
              }
            }, this.isAutoPlay);
          } else {
            clearInterval(this.interval);
            this.isPlaying = false;
          }
        })
      }, 1000);
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  onDotClick(event) {
    event.preventDefault;
    const slideScrollPosition = (event.currentTarget.dataset.index - 1) * this.sliderItemOffset;
    this.slider.scrollTo({
      left: slideScrollPosition
    })
  }
}

customElements.define('slider-component', SliderComponent);


document.addEventListener('DOMContentLoaded', function () {
  var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

  if ('IntersectionObserver' in window) {
    var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove('lazy');
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
  const videoPosters = document.querySelectorAll('.media--poster-image');
  if (videoPosters.length > 0) {
    videoPosters.forEach(videoWrapper => {
      const posterImage = videoWrapper.querySelector('img');
      const playButton = videoWrapper.querySelector('.deferred-media__poster-button');
      if (!posterImage) return;
      playButton.addEventListener('click', (e) => {
        posterImage.classList.add('visually-hidden');
        playButton.classList.add('visually-hidden');
        let videoEl = videoWrapper.querySelector('video');
        let isYoutube = false;

        if (!videoEl) {
          videoEl = video.getElementsByTagName('iframe')[0];
          isYoutube = true;
        };

        setTimeout(function () {
          if (isYoutube) {
            videoEl.setAttribute('src', videoEl.getAttribute('src') + '?autoplay=1');
          } else {
            videoEl.play();
          }
        }, 500);
      });
    })
  }
});

class DetailsTooltip extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.details.querySelector('summary');

    this.hoverMedia = window.matchMedia(`(hover: hover)`)

    this.handleHoverListener(this.hoverMedia);
  }

  handleHoverListener(e) {
    if (!e.matches) {
      this.details.removeAttribute('open');
      return;
    };
    this.details.addEventListener('mouseover', this.showTooltip.bind(this));
    this.details.addEventListener('mouseout', this.hideTooltip.bind(this));
  }

  showTooltip() {
    this.details.setAttribute('open', 'true');
  }
  hideTooltip() {
    this.details.removeAttribute('open');
  }
}
customElements.define('details-tooltip', DetailsTooltip);
